import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'

import classnames from 'classnames'

import { CommercialCalculator } from '../Calculators'

import { unitedNumber } from '../propTypes'
import * as info from './info'

import CalculationGroup from '../Widgets/CalculationGroup'

export default class LandResidualPrice extends Component {
  static propTypes = {
    calculator: PropTypes.instanceOf(CommercialCalculator).isRequired,
    data: PropTypes.shape({
      profit: unitedNumber,
      legalSiteAcquisitionCost: PropTypes.number,
      planning: PropTypes.number,
      surveys: PropTypes.number,
    }).isRequired,
    readOnly: PropTypes.bool,
    updateField: PropTypes.func,
  }

  state = {
    infoOpen: false,
  }

  toggleInfoOpen = () => this.setState({ infoOpen: ! this.state.infoOpen })

  handleFieldChangedFactory = (field) => (value) => this.props.updateField(field, value)

  render() {
    const { calculator, data, readOnly } = this.props

    const { infoOpen } = this.state

    const infoButtonClasses = classnames([
      'form-label__help-trigger',
      'form-label__help-trigger--alert',
      infoOpen && 'form-label__help-trigger--active',
    ])

    const infoHelpClasses = classnames([
      'form__help-text',
      infoOpen && 'form__help-text--active',
    ])

    return (
      <Fragment>
        <h2>Profit and Land Value</h2>

        <CalculationGroup
          readOnly={readOnly}
          field='profit'
          info={info.profit}
          label='Profit on cost'
          value={data.profit.value}
          unit={data.profit.unit}
          unitType='percentgdv-percentcost-fixed'
          onChange={readOnly ? null : this.handleFieldChangedFactory('profit')}
          average={calculator.getAverage(calculator.getDeveloperProfitTotal())}
          averageLabel={`Average per ${calculator.getPerUnitAreaLabel()}`}
          total={calculator.getDeveloperProfitTotal()}
          input={{ allowZero: true, autoFocus: true }}
        />
        <CalculationGroup
          readOnly={readOnly}
          field='legalSiteAcquisitionCost'
          info={info.legalSiteAcquisitionCost}
          label='Legal site acquisition cost'
          value={data.legalSiteAcquisitionCost}
          onChange={readOnly ? null : this.handleFieldChangedFactory('legalSiteAcquisitionCost')}
          average={calculator.getAverage(calculator.getLegalSiteAcquisitionCostTotal())}
          averageLabel={`Average per ${calculator.getPerUnitAreaLabel()}`}
          total={calculator.getLegalSiteAcquisitionCostTotal()}
          input={{ allowZero: true, prefix: '£' }}
        />
        <CalculationGroup
          readOnly={readOnly}
          field='planning'
          info={info.planning}
          label='Planning'
          value={data.planning}
          onChange={readOnly ? null : this.handleFieldChangedFactory('planning')}
          average={calculator.getAverage(calculator.getPlanningTotal())}
          averageLabel={`Average per ${calculator.getPerUnitAreaLabel()}`}
          total={calculator.getPlanningTotal()}
          input={{ allowZero: true, prefix: '£' }}
        />
        <CalculationGroup
          readOnly={readOnly}
          field='surveys'
          info={info.surveys}
          label='Surveys'
          value={data.surveys}
          onChange={readOnly ? null : this.handleFieldChangedFactory('surveys')}
          average={calculator.getAverage(calculator.getSurveysTotal())}
          averageLabel={`Average per ${calculator.getPerUnitAreaLabel()}`}
          total={calculator.getSurveysTotal()}
          input={{ allowZero: true, prefix: '£' }}
        />

        <div className='calculation-group hidden-print'>
          <label className='form__label form-label'>
            {'Stamp Duty – for calculation please click'}
            <button
              className={infoButtonClasses}
              onClick={this.toggleInfoOpen}
              title='Show/hide more info'
              type='button'
            >
              <span>i</span>
            </button>
          </label>
          {<div className={infoHelpClasses}>{info.stampDuty}</div>}
        </div>

        {info.toolDisclaimer && (
          <p>
            {info.toolDisclaimer}
          </p>
        )}
      </Fragment>
    )
  }
}
